import { customer_settingsApi as api } from "src/datahandling/redux/api/rtkQueryCodeGen/customer_settingsApi/customer_settingsApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getCompanySettingsByCompanyId: build.query<
      GetCompanySettingsByCompanyIdApiResponse,
      GetCompanySettingsByCompanyIdApiArg
    >({
      query: (queryArg) => ({
        url: `/company-settings/${queryArg.companyId}`,
        params: {
          applications: queryArg.applications,
        },
      }),
      extraOptions: {},
    }),
    putCompanySettingsByCompanyIdCommon: build.mutation<
      PutCompanySettingsByCompanyIdCommonApiResponse,
      PutCompanySettingsByCompanyIdCommonApiArg
    >({
      query: (queryArg) => ({
        url: `/company-settings/${queryArg.companyId}/common`,
        method: "PUT",
        body: queryArg.updateCompanySettingsRequestWeb,
      }),
      extraOptions: {},
    }),
    patchCompanySettingsByCompanyIdCommon: build.mutation<
      PatchCompanySettingsByCompanyIdCommonApiResponse,
      PatchCompanySettingsByCompanyIdCommonApiArg
    >({
      query: (queryArg) => ({
        url: `/company-settings/${queryArg.companyId}/common`,
        method: "PATCH",
        body: queryArg.patchCompanySettingsCommonRequestWeb,
      }),
      extraOptions: {},
    }),
    putCompanySettingsByCompanyIdApplicationAndApplicationName: build.mutation<
      PutCompanySettingsByCompanyIdApplicationAndApplicationNameApiResponse,
      PutCompanySettingsByCompanyIdApplicationAndApplicationNameApiArg
    >({
      query: (queryArg) => ({
        url: `/company-settings/${queryArg.companyId}/application/${queryArg.applicationName}`,
        method: "PUT",
        body: queryArg.body,
      }),
      extraOptions: {},
    }),
    patchCompanySettingsByCompanyIdApplicationAndApplicationName:
      build.mutation<
        PatchCompanySettingsByCompanyIdApplicationAndApplicationNameApiResponse,
        PatchCompanySettingsByCompanyIdApplicationAndApplicationNameApiArg
      >({
        query: (queryArg) => ({
          url: `/company-settings/${queryArg.companyId}/application/${queryArg.applicationName}`,
          method: "PATCH",
          body: queryArg.body,
        }),
        extraOptions: {},
      }),
    deleteCompanySettingsByCompanyIdApplicationAndApplicationName:
      build.mutation<
        DeleteCompanySettingsByCompanyIdApplicationAndApplicationNameApiResponse,
        DeleteCompanySettingsByCompanyIdApplicationAndApplicationNameApiArg
      >({
        query: (queryArg) => ({
          url: `/company-settings/${queryArg.companyId}/application/${queryArg.applicationName}`,
          method: "DELETE",
          params: {
            additionalApplications: queryArg.additionalApplications,
          },
        }),
        extraOptions: {},
      }),
    deleteCompanySettingsByCompanyIdApplication: build.mutation<
      DeleteCompanySettingsByCompanyIdApplicationApiResponse,
      DeleteCompanySettingsByCompanyIdApplicationApiArg
    >({
      query: (queryArg) => ({
        url: `/company-settings/${queryArg.companyId}/application`,
        method: "DELETE",
      }),
      extraOptions: {},
    }),
    getUserSettings: build.query<
      GetUserSettingsApiResponse,
      GetUserSettingsApiArg
    >({
      query: (queryArg) => ({
        url: `/user-settings`,
        params: {
          applications: queryArg.applications,
        },
      }),
      extraOptions: {},
    }),
    putUserSettingsCommon: build.mutation<
      PutUserSettingsCommonApiResponse,
      PutUserSettingsCommonApiArg
    >({
      query: (queryArg) => ({
        url: `/user-settings/common`,
        method: "PUT",
        body: queryArg.updateUserSettingsRequestWeb,
      }),
      extraOptions: {},
    }),
    patchUserSettingsCommon: build.mutation<
      PatchUserSettingsCommonApiResponse,
      PatchUserSettingsCommonApiArg
    >({
      query: (queryArg) => ({
        url: `/user-settings/common`,
        method: "PATCH",
        body: queryArg.patchUserSettingsCommonRequestWeb,
      }),
      extraOptions: {},
    }),
    putUserSettingsApplicationByApplicationName: build.mutation<
      PutUserSettingsApplicationByApplicationNameApiResponse,
      PutUserSettingsApplicationByApplicationNameApiArg
    >({
      query: (queryArg) => ({
        url: `/user-settings/application/${queryArg.applicationName}`,
        method: "PUT",
        body: queryArg.body,
      }),
      extraOptions: {},
    }),
    patchUserSettingsApplicationByApplicationName: build.mutation<
      PatchUserSettingsApplicationByApplicationNameApiResponse,
      PatchUserSettingsApplicationByApplicationNameApiArg
    >({
      query: (queryArg) => ({
        url: `/user-settings/application/${queryArg.applicationName}`,
        method: "PATCH",
        body: queryArg.body,
      }),
      extraOptions: {},
    }),
    deleteUserSettingsApplicationByApplicationName: build.mutation<
      DeleteUserSettingsApplicationByApplicationNameApiResponse,
      DeleteUserSettingsApplicationByApplicationNameApiArg
    >({
      query: (queryArg) => ({
        url: `/user-settings/application/${queryArg.applicationName}`,
        method: "DELETE",
        params: {
          additionalApplications: queryArg.additionalApplications,
        },
      }),
      extraOptions: {},
    }),
    deleteUserSettingsApplication: build.mutation<
      DeleteUserSettingsApplicationApiResponse,
      DeleteUserSettingsApplicationApiArg
    >({
      query: () => ({ url: `/user-settings/application`, method: "DELETE" }),
      extraOptions: {},
    }),

  }),
  overrideExisting: false,
});
export { injectedRtkApi as customer_settingsApi };
export type GetCompanySettingsByCompanyIdApiResponse =
  /** status 200 OK */ WebCompanySettings;
export type GetCompanySettingsByCompanyIdApiArg = {
  companyId: string;
  applications?: string[];
};
export type PutCompanySettingsByCompanyIdCommonApiResponse =
  /** status 200 OK */ WebCompanySettingsCommon;
export type PutCompanySettingsByCompanyIdCommonApiArg = {
  companyId: string;
  updateCompanySettingsRequestWeb: UpdateCompanySettingsRequestWeb;
};
export type PatchCompanySettingsByCompanyIdCommonApiResponse =
  /** status 200 OK */ WebCompanySettingsCommon;
export type PatchCompanySettingsByCompanyIdCommonApiArg = {
  companyId: string;
  patchCompanySettingsCommonRequestWeb: PatchCompanySettingsCommonRequestWeb;
};
export type PutCompanySettingsByCompanyIdApplicationAndApplicationNameApiResponse =
  /** status 200 OK */ WebCompanySettings;
export type PutCompanySettingsByCompanyIdApplicationAndApplicationNameApiArg = {
  companyId: string;
  applicationName: string;
  body: any;
};
export type PatchCompanySettingsByCompanyIdApplicationAndApplicationNameApiResponse =
  /** status 200 OK */ WebCompanySettings;
export type PatchCompanySettingsByCompanyIdApplicationAndApplicationNameApiArg =
  {
    companyId: string;
    applicationName: string;
    body: any;
  };
export type DeleteCompanySettingsByCompanyIdApplicationAndApplicationNameApiResponse =
  /** status 200 OK */ WebCompanySettings;
export type DeleteCompanySettingsByCompanyIdApplicationAndApplicationNameApiArg =
  {
    companyId: string;
    applicationName: string;
    additionalApplications?: string[];
  };
export type DeleteCompanySettingsByCompanyIdApplicationApiResponse =
  /** status 200 OK */ WebCompanySettings;
export type DeleteCompanySettingsByCompanyIdApplicationApiArg = {
  companyId: string;
};
export type GetUserSettingsApiResponse = /** status 200 OK */ WebUserSettings;
export type GetUserSettingsApiArg = {
  applications?: string[];
};
export type PutUserSettingsCommonApiResponse =
  /** status 200 OK */ WebUserSettingsCommon;
export type PutUserSettingsCommonApiArg = {
  updateUserSettingsRequestWeb: UpdateUserSettingsRequestWeb;
};
export type PatchUserSettingsCommonApiResponse =
  /** status 200 OK */ WebUserSettingsCommon;
export type PatchUserSettingsCommonApiArg = {
  patchUserSettingsCommonRequestWeb: PatchUserSettingsCommonRequestWeb;
};
export type PutUserSettingsApplicationByApplicationNameApiResponse =
  /** status 200 OK */ WebUserSettings;
export type PutUserSettingsApplicationByApplicationNameApiArg = {
  applicationName: string;
  body: any;
};
export type PatchUserSettingsApplicationByApplicationNameApiResponse =
  /** status 200 OK */ WebUserSettings;
export type PatchUserSettingsApplicationByApplicationNameApiArg = {
  applicationName: string;
  body: any;
};
export type DeleteUserSettingsApplicationByApplicationNameApiResponse =
  /** status 200 OK */ WebUserSettings;
export type DeleteUserSettingsApplicationByApplicationNameApiArg = {
  applicationName: string;
  additionalApplications?: string[];
};
export type DeleteUserSettingsApplicationApiResponse =
  /** status 200 OK */ WebUserSettings;
export type DeleteUserSettingsApplicationApiArg = void;
export type UiTheme = "Auto" | "Light" | "Dark";
export type Language = "Auto" | "Norwegian" | "English" | "Spanish";
export type WebCompanySettingsCommon = {
  uiTheme?: UiTheme;
  language?: Language;
};
export type WebCompanySettings = {
  companyId: string;
  common: WebCompanySettingsCommon;
  applicationSpecific?: {
    [key: string]: any;
  };
};
export type UpdateCompanySettingsRequestWeb = {
  language: Language;
  uiTheme: UiTheme;
};
export type PatchCompanySettingsCommonRequestWeb = {
  language?: Language;
  uiTheme?: UiTheme;
};
export type WebUserSettingsCommon = {
  uiTheme?: UiTheme;
  language?: Language;
};
export type WebUserSettings = {
  userId: string;
  common: WebUserSettingsCommon;
  applicationSpecific?: {
    [key: string]: any;
  };
};
export type UpdateUserSettingsRequestWeb = {
  language: Language;
  uiTheme: UiTheme;
};
export type PatchUserSettingsCommonRequestWeb = {
  language?: Language;
  uiTheme?: UiTheme;
};
export const {
  useGetCompanySettingsByCompanyIdQuery,
  usePutCompanySettingsByCompanyIdCommonMutation,
  usePatchCompanySettingsByCompanyIdCommonMutation,
  usePutCompanySettingsByCompanyIdApplicationAndApplicationNameMutation,
  usePatchCompanySettingsByCompanyIdApplicationAndApplicationNameMutation,
  useDeleteCompanySettingsByCompanyIdApplicationAndApplicationNameMutation,
  useDeleteCompanySettingsByCompanyIdApplicationMutation,
  useGetUserSettingsQuery,
  usePutUserSettingsCommonMutation,
  usePatchUserSettingsCommonMutation,
  usePutUserSettingsApplicationByApplicationNameMutation,
  usePatchUserSettingsApplicationByApplicationNameMutation,
  useDeleteUserSettingsApplicationByApplicationNameMutation,
  useDeleteUserSettingsApplicationMutation,
} = injectedRtkApi;

import { customer_settingsApi } from "./customer_settingsApi";
export type customer_settingsApiType = typeof customer_settingsApi;
